import React, { ButtonHTMLAttributes } from "react";
import { buttonClasses } from "./buttonStyles";
import classNames from "classnames";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
  color?: "primary" | "secondary" | "success";
  inverted?: boolean;
  size?: "small" | "medium";
};

const Button: React.FC<ButtonProps> = ({
  label,
  color,
  inverted = false,
  children,
  size = "medium",
  ...buttonProps
}) => {
  const classes = classNames(
    buttonClasses({ color, inverted, size }),
    buttonProps.className,
  );
  return (
    <button type="button" {...buttonProps} className={classes}>
      {label ? label : children}
    </button>
  );
};

export default Button;
